import { useCallback, useEffect } from 'react';
import { useApiLoading, useApiGet } from 'react-reqq-lite';

import { useCurrentAccount } from 'modules/auth/hooks';

import * as actions from './actions';

export const useCashbackList = (biller_id, params) => {
  const isLoading = useApiLoading('CASHBACK_LIST', 'get');
  const list = useApiGet('CASHBACK_LIST', []);
  const pager = useApiGet('CASHBACK_PAGER', {});
  const [, { role }] = useCurrentAccount();
  useEffect(() => {
    actions.cashbackList(biller_id, role, params);
  }, [biller_id, params, role]);
  return [isLoading, list, pager];
};

export const useSelectedCashback = (biller_id, cashback_id) => {
  const isLoading = useApiLoading('SELECTED_CASHBACK', 'get');
  const data = useApiGet('SELECTED_CASHBACK', {});
  const [, { role }] = useCurrentAccount();
  useEffect(() => {
    if (biller_id && cashback_id)
      actions.selectedCashback(biller_id, cashback_id, role);
  }, [biller_id, cashback_id, role]);
  return [isLoading, data];
};

export const useAddCashback = () => {
  const isLoading = useApiLoading('ADD_CASHBACK', 'post');
  const [, { role }] = useCurrentAccount();
  const submit = useCallback(
    (payload, biller_id, onSuccess) => {
      actions.addCashback(payload, biller_id, role, onSuccess);
    },
    [role]
  );
  return [submit, isLoading];
};

export const useUpdateCashback = () => {
  const isLoading = useApiLoading('UPDATE_CASHBACK', 'put');
  const [, { role }] = useCurrentAccount();
  const submit = useCallback(
    (payload, biller_id, cashback_id, onSuccess) => {
      actions.updateCashback(payload, biller_id, cashback_id, role, onSuccess);
    },
    [role]
  );
  return [submit, isLoading];
};

export const useDeleteCashback = () => {
  const isLoading = useApiLoading('DELETE_CASHBACK', 'remove');
  const [, { role }] = useCurrentAccount();
  const submit = useCallback(
    (biller_id, cashback_id) => {
      actions.deleteCashback(biller_id, cashback_id, role);
    },
    [role]
  );
  return [submit, isLoading];
};
